import { useRouter } from 'next/router'

import logger from '@/utils/logger'
import { useAppDispatch } from '@/utils/useAppDispatch'
import { useAppSelector } from '@/utils/useAppSelector'

import { closeOverlay, setOverlayPath } from './overlaySlice'

type UrlObjectLike = {
  pathname?: string
  query?: Record<string, string>
}

const useProductOverlay = () => {
  const dispatch = useAppDispatch()
  const router = useRouter()
  const originalPath = useAppSelector((state) => state.overlay.originalPath)
  const productOpen = useAppSelector((state) => state.overlay.view.type === 'PRODUCT')

  const openOverlay = (path: UrlObjectLike, alias?: UrlObjectLike) => {
    if (!productOpen) {
      dispatch(setOverlayPath({ originalPath: router.asPath }))
    }
    const pathWithExistingQuery = {
      ...path,
      query: {
        ...router.query,
        ...path.query,
      },
    }
    logger.debug({ msg: 'open product overlay', path, alias })
    router.push(pathWithExistingQuery, alias, { shallow: true })
  }

  return {
    openOverlay,
    closeOverlay: () => {
      logger.debug({ msg: 'close product overlay', originalPath })
      dispatch(closeOverlay)
      if (originalPath) {
        router.push(originalPath, undefined, { shallow: true })
      } else {
        router.back()
      }
    },
  }
}

export default useProductOverlay
